// One-shot cleanup for users who tried the experimental on-device LLM
// (LFM2.5-Thinking-1.2B) before it was removed. Deletes:
//   - the `access.ai.models` IndexedDB database (~731 MB blob)
//   - the `access.aiActivated` localStorage flag
//   - the session banner-dismiss flag
//
// Safe to call multiple times; keyed on a localStorage marker so the actual
// work only runs once per browser.

const CLEANUP_DONE_KEY = 'access.ai.legacy_cleanup_done_v1';
const LEGACY_DB_NAME   = 'access.ai.models';
const LEGACY_LS_KEYS   = ['access.aiActivated'];
const LEGACY_SS_KEYS   = ['access.briefing.bannerDismissed'];

export function cleanupLegacyAI() {
  try {
    if (localStorage.getItem(CLEANUP_DONE_KEY) === 'true') return;
  } catch (_) { return; }

  // Best-effort: delete the IndexedDB database. indexedDB.deleteDatabase()
  // is fire-and-forget — we don't block the app on it.
  try {
    if (typeof indexedDB !== 'undefined' && indexedDB.deleteDatabase) {
      indexedDB.deleteDatabase(LEGACY_DB_NAME);
    }
  } catch (_) { /* ignore */ }

  try {
    LEGACY_LS_KEYS.forEach(k => localStorage.removeItem(k));
  } catch (_) { /* ignore */ }

  try {
    LEGACY_SS_KEYS.forEach(k => sessionStorage.removeItem(k));
  } catch (_) { /* ignore */ }

  try {
    localStorage.setItem(CLEANUP_DONE_KEY, 'true');
  } catch (_) { /* ignore */ }
}
